export default "__VITE_ASSET__m4RJycJp__"